import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";

export const MadingDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    window.scrollTo(0, 0);
    setAppBar({ title: "Informasi Terkini", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Informasi Terkini",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-10">
      <div className="tw-p-4 card-body">
        <div className="tw-text-base tw-font-bold tw-mb-2">
          <div className="tw-block tw-text-xs tw-font-light tw-text-text-secondary">
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>
        </div>
        <img
          className="tw-w-full tw-h-full tw-rounded-xl tw-object-cover"
          src={`https://sip2.darululumkalbar.com//assets/mading/${state.gambar}`}
          alt=""
        />
        <div className="tw-my-4 tw-text-base tw-text-text-primary tw-font-semibold">
          {state.judul}
        </div>
        <pre
          className="tw-mb-6 tw-text-sm tw-font-medium tw-text-text-primary"
          style={{
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            overflow: "auto",
            letterSpacing: "1.3px",
          }}
        >
          {state.pesan}
        </pre>
      </div>
    </div>
  );
};
